import React from 'react';
import NotificactionScreen from '../../../components/Common/NotificactionScreen/NotificactionScreen';
import WarningIcon from '../../../components/icons/WarningIcon';
import { useDispatch } from 'react-redux';
import { logout } from '../../../actions/associatesActions';
import { useHistory } from 'react-router-dom';
import ContentApp from '../../../components/ContentApp';
import { useTranslation } from 'react-i18next';

const Unauthorized = () => {
  const { t } = useTranslation();

  const history = useHistory();
  const dispatch = useDispatch();
  const handleSignOut = () => {
    dispatch(logout());
    history.push('/login');
  };

  return (
    <ContentApp>
      <div className='d-flex align-items-center justify-content-center mt-5'>
        <WarningIcon color='var(--color-primary)' size='120px' />
      </div>
      <div className='text-left px-4'>
        <div
          className='font-large bold lh-title mt-5 px-1'
          style={{ color: 'var(--color-font-primary)' }}
        >
          {t('unauthorized.title1')}
        </div>
        <div className='text-secondary font-normal mt-2 px-1'>{t('unauthorized.title2')}</div>
      </div>
      <div
        className='text-center mt-3 text-secondary'
        style={{ position: 'fixed', bottom: 40, width: '100%', left: 0 }}
        onClick={handleSignOut}
      >
        {t('menu.logout')}
      </div>
    </ContentApp>
  );
};

export default Unauthorized;
